require('./brokerHireDerivativesAccountView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const Immutable = require('immutable');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerHireDerivativesAccountWizard = require('components/broker/brokerHireDerivativesAccount/brokerHireDerivativesAccountWizard');
const BrokerHireDerivativesAccountSuccess = require('components/broker/brokerHireDerivativesAccount/brokerHireDerivativesAccountSuccess/brokerHireDerivativesAccountSuccess');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerHireDerivativesAccountActions = require('actions/brokerHireDerivativesAccount');

// @constants
const { FIRST_STEP } = require('constants/index');

const CLASS_NAME = 'broker-hire-derivatives-account-view';

const HELP_LINK = ''; // @hardcoded

class BrokerHireDerivativesAccountView extends React.Component {

    componentWillUnmount() {
        this.props.onReset();
    }

    buildSideColumn() {
        const { immBrokerHireDerivativesAccount, immBrokerWallets } = this.props;
        let content;

        if (immBrokerHireDerivativesAccount.get('visibleStep') - 1 === FIRST_STEP) {
            // @hardcoded
            content = (
                <OKSectionBox>
                    <div className={`${CLASS_NAME}__sidecolumn-header`}>
                        <h4><FormattedText value="hireDerivativesAccount-newDerivativesAccount" /></h4>
                    </div>
                    <FormattedText value="hireDerivativesAccount-step1SideColumn" />
                </OKSectionBox>
            );
        } else {
            const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
                ['steps', FIRST_STEP, 'selectedAssociatedContract']
            );
            const immSelectedAssociatedAccount = immBrokerHireDerivativesAccount.getIn(
                ['contracts', selectedAssociatedContract]
            );
            const immOwner = immBrokerWallets.get('allFuturesList').find(
                immFutures => immFutures.getIn(['cviejo', 'numerodecontrato']) == immSelectedAssociatedAccount.get('contractNumber')
            ) || Immutable.fromJS({});
            const immFirstStepInterveners = immBrokerHireDerivativesAccount.getIn(
                ['steps', FIRST_STEP, 'interveners']
            );
            const amountObject = {
                amount: immSelectedAssociatedAccount.get('balance'),
                currency: immSelectedAssociatedAccount.get('currency')
            };
            const plainAmountObject = getPlainAmountObject(amountObject);
            const balance = (
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            );
            const interveners = immFirstStepInterveners.map((immIntervener, index) => {
                return (
                    <div key={index} className={`${CLASS_NAME}__sidecolumn-information`}>
                        <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                            <FormattedText
                                value="hireDerivativesAccount-owner"
                                format="uppercase"
                            />
                        </h5>
                        <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                            {immIntervener.get('name')}
                        </div>
                    </div>
                );
            });

            content = (
                <OKSectionBox>
                    <div className={`${CLASS_NAME}__sidecolumn-header`}>
                        <h4><FormattedText value="hireDerivativesAccount-hireData" /></h4>
                    </div>

                    <div className={`${CLASS_NAME}__sidecolumn-information`}>
                        <h5 className={`${CLASS_NAME}__sidecolumn-information-title`}>
                            <FormattedText
                                value="hireDerivativesAccount-associatedAccountLabel"
                                format="uppercase"
                            />
                        </h5>
                        <div className={`${CLASS_NAME}__sidecolumn-information-primary-text`}>
                            {immSelectedAssociatedAccount.get('accountType')}
                        </div>
                        <div className={`${CLASS_NAME}__sidecolumn-information-secondary-text`}>
                            {immOwner.getIn(['ibanComplex', 'codbban'], '')}
                        </div>
                    </div>

                    <div className={`${CLASS_NAME}__sidecolumn-information`}>
                        <FormattedText
                            value="hireDerivativesAccount-firstOwner"
                            injectedStrings={[
                                immOwner.get('nombretitular', '').trim(),
                                immOwner.getIn(['descIntervenciones', 'nomTipInterv'], '').trim()
                            ]}
                        />
                        <br />
                        <FormattedTextWithComponents
                            value="hireDerivativesAccount-balanceAccount"
                            injectedComponents={[balance]}
                        />
                    </div>

                    <div className={`${CLASS_NAME}__sidecolumn-header`}>
                        <h4><FormattedText value="hireDerivativesAccount-interveners" /></h4>
                    </div>

                    {interveners}
                </OKSectionBox>
            );
        }

        return content;
    }

    buildSuccess() {
        const { immBrokerHireDerivativesAccount, immBrokerWallets } = this.props;
        return (
            <BrokerHireDerivativesAccountSuccess
                immBrokerHireDerivativesAccount={immBrokerHireDerivativesAccount}
                immBrokerWallets={immBrokerWallets}
            />
        );
    }

    buildWizard() {
        const {
            immBrokerHireDerivativesAccount,
            immBrokerWallets,
            fetchAssociatedAccounts,
            fetchDerivatives,
            onAddIntervener,
            onRemoveIntervener,
            onResetInterveners,
            onSelectAssociatedAccount,
            onChangeAcceptManifest,
            onValidateStep,
            onSetVisibleStep,
            onFinish
        } = this.props;

        return (
            <BrokerHireDerivativesAccountWizard
                immBrokerHireDerivativesAccount={immBrokerHireDerivativesAccount}
                immBrokerWallets={immBrokerWallets}
                fetchAssociatedAccounts={fetchAssociatedAccounts}
                fetchDerivatives={fetchDerivatives}
                onAddIntervener={onAddIntervener}
                onRemoveIntervener={onRemoveIntervener}
                onResetInterveners={onResetInterveners}
                onSelectAssociatedAccount={onSelectAssociatedAccount}
                onChangeAcceptManifest={onChangeAcceptManifest}
                onValidateStep={onValidateStep}
                onSetVisibleStep={onSetVisibleStep}
                onFinish={onFinish}
            />
        );
    }

    render() {
        const { immBrokerHireDerivativesAccount, immVariables } = this.props;
        const breadcrumb = [
            {
                text: formatText('hireDerivativesAccount-investments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('hireDerivativesAccount-myWallet'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('hireDerivativesAccount-hireNewDerivativesAccount'),
                url: ''
            }
        ];
        let commissionsButton;
        let helpButton;
        let content;

        if (immBrokerHireDerivativesAccount.get('finished')) {
            content = this.buildSuccess();
        } else {
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
            commissionsButton = (
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    onClick={() => window.open(fees_url, '_blank')}
                >
                    <FormattedText value="cashCharge-commissions" />
                </OKButton>
            );
            helpButton = (
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    onClick={() => window.open(HELP_LINK, '_blank')}
                >
                    <FormattedText value="cashCharge-help" />
                </OKButton>
            );
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <section className={CLASS_NAME}>
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('hireDerivativesAccount-title')}
                    >
                        {commissionsButton}
                        {helpButton}
                    </OKHeaderSubPage>
                </OKCover>
                <section className={`${CLASS_NAME}__body`}>
                    {content}
                </section>
            </section>
        );
    }
}

BrokerHireDerivativesAccountView.propTypes = {
    immBrokerHireDerivativesAccount: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    fetchAssociatedAccounts: PropTypes.func.isRequired,
    fetchDerivatives: PropTypes.func.isRequired,
    onAddIntervener: PropTypes.func.isRequired,
    onRemoveIntervener: PropTypes.func.isRequired,
    onResetInterveners: PropTypes.func.isRequired,
    onSelectAssociatedAccount: PropTypes.func.isRequired,
    onChangeAcceptManifest: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired
};

module.exports.constructor = BrokerHireDerivativesAccountView;
module.exports.BrokerHireDerivativesAccountView = connect(
    (state) => ({
        immBrokerHireDerivativesAccount: state.brokerHireDerivativesAccount,
        immBrokerWallets: state.brokerWallets,
        immVariables: state.globalVariables
    }),
    {
        fetchAssociatedAccounts: BrokerHireDerivativesAccountActions.fetchAssociatedAccounts,
        fetchDerivatives: BrokerHireDerivativesAccountActions.fetchInterveners,
        onAddIntervener: BrokerHireDerivativesAccountActions.addIntervener,
        onRemoveIntervener: BrokerHireDerivativesAccountActions.removeIntervener,
        onResetInterveners: BrokerHireDerivativesAccountActions.resetInterveners,
        onSelectAssociatedAccount: BrokerHireDerivativesAccountActions.selectAssociatedAccount,
        onChangeAcceptManifest: BrokerHireDerivativesAccountActions.changeAcceptManifest,
        onValidateStep: BrokerHireDerivativesAccountActions.validateStep,
        onSetVisibleStep: BrokerHireDerivativesAccountActions.setVisibleStep,
        onFinish: BrokerHireDerivativesAccountActions.finish,
        onReset: BrokerHireDerivativesAccountActions.reset
    }
)(BrokerHireDerivativesAccountView);